import Vue from 'vue'
import VueMeta from 'vue-meta'
import App from './App.vue'
import router from './router/index'
import store from './store/index'

Vue.config.productionTip = false
Vue.use(VueMeta);

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
